module.exports = __webpack_public_path__ + "img/W3P-logo.2cd7e177.svg";